import React, { useState } from "react";
import { Dialog, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../RenameFormPopup/RenameFormPopup.module.css";
import CancelBtn from "../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../components/Buttons/SaveBtn";

const ButtonRenamePopup = (props: any) => {
  const { btnRenamePopup, onClose, setUpdatedButtonName, updatedButtonName } =
    props;

  const [btnName, setBtnName] = useState<string>("");
  const handleChangeName = (e: any) => {
    setBtnName(e.target.value);
  };

  const handleClose = () => {
    onClose();
    setBtnName("");
  };

  const handleSave = () => {
    setUpdatedButtonName(btnName);
    onClose();
  };

  React.useEffect(() => {
    setBtnName(updatedButtonName);
  }, [updatedButtonName]);

  return (
    <Dialog
      open={btnRenamePopup}
      onClose={onClose}
      sx={{
        zIndex: "99999",
        minWidth: "400px",
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "400px",
          maxHeight: "290px",
          minHeight: "165px",
          padding: "24px",
          borderRadius: "12px",
          boxShadow:
            "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
          left: "5%",
          top: "8%",
          background: "#FFFFFF",
          overflow: "hidden",
        },
      }}
    >
      <div>
        <div className={styles.closeModalButton}>
          <CloseIcon sx={{ color: "#555555" }} onClick={handleClose} />
        </div>
        <div className={styles.modalTitle}>Enter Button Name</div>
        <TextField
          variant="outlined"
          value={btnName}
          onChange={handleChangeName}
          placeholder="Enter Button name"
          fullWidth
          inputProps={{
            style: {
              padding: "10px 12px",
              backgroundColor: "#FFF",
              borderRadius: "4px",
            },
          }}
        />
        <div className={styles.buttonSection}>
          <CancelBtn onClick={handleClose} />
          <SaveBtn
            buttonText="Save"
            onClick={handleSave}
            disabled={btnName === ""}
          />
        </div>
      </div>
    </Dialog>
  );
};
export default ButtonRenamePopup;
